import {ZyusetuFieldKeyFragmentFragment, ZyusetuFieldKeyType,} from "@/graphql/graphql";
import {FormSchema} from "@/components/pages/Zyusetu/ZyusetuEditorSection.tsx";
import {Controller, useFormContext} from "react-hook-form";
import {Checkbox, FormControlLabel, FormGroup, FormHelperText,} from "@mui/material";
import {zyusetuValueIntoZodValue} from "@/hooks/useGetFirstContent";

interface ZyusetuBooleanValueProps {
  fieldKey: ZyusetuFieldKeyFragmentFragment;
  onFocus: () => void;
  updateField: (
    keyId: string,
    keyName: string,
    value: FormSchema<ZyusetuFieldKeyType.Boolean>[string],
  ) => Promise<void>;
  isAvailable: boolean;
}

export function ZyusetuBooleanValue({
                                      fieldKey,
                                      onFocus,
                                      updateField,
                                      isAvailable,
                                    }: ZyusetuBooleanValueProps) {
  const {control} = useFormContext<FormSchema<ZyusetuFieldKeyType.Boolean>>();
  
  return (
    <Controller
      name={fieldKey.keyName}
      control={control}
      render={({field, formState: {errors}}) => (
        <FormGroup {...field}>
          <FormControlLabel
            control={
              <Checkbox
                disabled={!isAvailable}
                inputRef={field.ref}
                checked={field.value?.value ?? false}
                onChange={async (_, checked) => {
                  const value = zyusetuValueIntoZodValue(fieldKey, checked);
                  field.onChange(value);
                  if (errors?.[fieldKey.keyName]?.value?.message) return;
                  // @ts-expect-error this cant be parsed
                  await updateField(fieldKey.id, fieldKey.keyName, value);
                }}
              />
            }
            onMouseEnter={onFocus}
            label={fieldKey.keyStyle.fieldLabel}
            onFocus={onFocus}
          />
          {errors?.[fieldKey.keyName]?.value?.message &&
            <FormHelperText style={{color: "red"}}>
              {errors?.[fieldKey.keyName]?.value?.message || ""}
            </FormHelperText>}
        </FormGroup>
      )}
    />
  );
}
